import { Search } from 'lucide-react';

type QuickSearchKey = 'grnNumber' | 'partNumber' | 'supplierName';

interface DeliveryQuickSearchProps {
  values: Record<QuickSearchKey, string>;
  /** The supplier box is hidden in the supplier view, where the only supplier is the viewer. */
  showSupplier: boolean;
  onChange: (key: QuickSearchKey, value: string) => void;
}

const BOXES: { key: QuickSearchKey; placeholder: string; label: string }[] = [
  { key: 'grnNumber', placeholder: 'Quick search GRN Number...', label: 'Quick search by GRN number' },
  { key: 'partNumber', placeholder: 'Quick search Part Number...', label: 'Quick search by part number' },
  { key: 'supplierName', placeholder: 'Quick search Supplier...', label: 'Quick search by supplier name' },
];

/**
 * Always-visible quick searches above the Deliveries grid: GRN number, part
 * number and (customer view) supplier name. Each shares its debounced text
 * filter with the Show Filters panel, so typing in one fills the other and
 * they AND with every other filter. Supplier matches on NAME (CR-7342),
 * separately from the panel's exact-id supplier dropdown.
 */
export default function DeliveryQuickSearch({ values, showSupplier, onChange }: DeliveryQuickSearchProps) {
  return (
    <>
      {BOXES.filter(({ key }) => showSupplier || key !== 'supplierName').map(({ key, placeholder, label }) => (
        <div key={key} className="relative">
          <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground pointer-events-none" />
          <input
            type="text"
            value={values[key]}
            onChange={(e) => onChange(key, e.target.value)}
            placeholder={placeholder}
            className="pl-8 pr-2 py-1.5 text-sm border rounded-lg w-56"
            aria-label={label}
          />
        </div>
      ))}
    </>
  );
}
